<template>
    <div>
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "UserMessagesWrapper"
    }
</script>

<style scoped>

</style>